import { datadogLogs } from '@datadog/browser-logs';
import { IChange } from 'json-diff-ts';

import Organization from '@/common/models/memberships/Organization';
import { environment } from '@/globals';
import rootStore from '@/store';
import LocalCache from '@/utils/LocalCache';

const clientToken = 'pubfceaa3903deffb5596737b853ee787f2';

export default class DatadogApi {
  static init() {
    datadogLogs.init({
      clientToken,
      site: 'datadoghq.com',
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
    });
  }

  static sendEvent(action: string, context?: Record<string, string | number>) {
    datadogLogs.logger.info(action, context);
  }

  static logUnexpectedChange(diffs: IChange[]) {
    const org = LocalCache.get('organization');
    const orgID = org != null ? Organization.fromApi(org).id : null;

    DatadogApi.sendEvent('unexpected_entity_change_on_load', {
      environment,
      organization_id: orgID,
      user_id: rootStore.getters.user?.id,
      page: window.location.pathname,
      url: 'N/A',
      method: 'N/A',
      status: 'N/A',
      notes: JSON.stringify(diffs),
    });
  }
}

DatadogApi.init();
